module.exports = __webpack_public_path__ + "static/media/Logo_Octiva_WHITE_RGB_HR.9421e26f.png";